module.exports = __webpack_public_path__ + "img/edit-row.35aa7cc0.svg";